import { render, staticRenderFns } from "./CommissionAuthorizationSpecial.vue?vue&type=template&id=5cf929e4&scoped=true"
import script from "./CommissionAuthorizationSpecial.vue?vue&type=script&lang=js"
export * from "./CommissionAuthorizationSpecial.vue?vue&type=script&lang=js"
import style0 from "./CommissionAuthorizationSpecial.vue?vue&type=style&index=0&id=5cf929e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf929e4",
  null
  
)

export default component.exports